import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useRef } from 'react';

// import singlepost from './assets/blogimage/blog/post-images/feat-img-2.jpg';
import './images/blogimage/css/animate.css';
import './images/blogimage/css/splitting.css';
import './images/blogimage/css/main-LTR-1.css';
import './images/blogimage/css/all.min.css';
import './images/blogimage/css/blog.css';
import Footer from './footer';
import NavbarComponent from './navbar';

// Utility function to create URL-friendly slugs (copied from BlogPage, good for consistency)
const slugify = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')       // Replace spaces with -
    .replace(/[^\w-]+/g, '')   // Remove all non-word chars
    .replace(/--+/g, '-')       // Replace multiple - with single -
    .replace(/^-+/, '')         // Trim - from start of text
    .replace(/-+$/, '');        // Trim - from end of text
};

const BlogDetails = () => {
  const [blog, setBlog] = useState(null); // State for the single blog post being displayed
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Sidebar states (copied from BlogPage)
  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const location = useLocation();
  const { slug } = useParams(); // Get the slug from the URL (e.g., /blogs/:slug)
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  const [isTablet, setIsTablet] = useState(false);

  // Function to check window size for tablet view
  const checkWindowSize = () => {
    setIsTablet(window.innerWidth <= 1024);
  };

  useEffect(() => {
    checkWindowSize();
    window.addEventListener('resize', checkWindowSize);
    return () => {
      window.removeEventListener('resize', checkWindowSize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount/route change
    setLoading(true);     // Start loading for main blog content
    setError(null);       // Clear previous errors
    setBlog(null);        // Clear previous blog data

    const fetchMainBlogDetails = async () => {
      let blogIdToFetch = null;
      // blogIdToFetch =1039;

      // 1. Prioritize blogId from location.state (passed from BlogPage)
      if (location.state && typeof location.state.blogId === 'number') {
        blogIdToFetch = location.state.blogId;
      
      }
      
      // 2. Fallback: If no valid blogId from state, check URL search params (less ideal if using slugs)
      else if (new URLSearchParams(window.location.search).get('blogId')) {
        const idFromUrl = parseInt(new URLSearchParams(window.location.search).get('blogId'));
        if (!isNaN(idFromUrl)) {
          blogIdToFetch = idFromUrl;
        }
      }
      // 3. Fallback (If your API supported fetching by slug directly - currently commented out)
   else if (slug) {
  try {
    const slugResponse = await axios.get(
      `https://fittex.io/jeevanapi/api/apptoodhublog?slug=${slug}`
    );
    blogIdToFetch = slugResponse.data?.data?.blogInfo?.[0]?.blog_Id;

    if (blogIdToFetch) {
      // ⬅️ second API call with blogId
      const response = await axios.get(
        `https://fittex.io/jeevanapi/api/apptoodhublog?blogId=${blogIdToFetch}`
      );
      setBlog(response.data?.data?.blogInfo?.[0] || null);
    } else {
      setError("No blog found for this slug.");
    }
  } catch (slugError) {
    console.error("Error resolving slug to blogId:", slugError);
    setError("Could not find blog by slug.");
  } finally {
    setLoading(false);
  }
  return; // ⬅️ stop here
}

  // alert(blogIdToFetch);


      if (blogIdToFetch && !isNaN(blogIdToFetch)) {
        try {
          const response = await axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?blogId=${blogIdToFetch}`);
          const blogData = response.data?.data?.blogInfo?.[0];

          if (blogData) {
            setBlog(blogData);
          } else {
            setError("Blog post not found for the given ID.");
          }
        } catch (apiError) {
          console.error("Error fetching blog details:", apiError);
          setError("Failed to load blog post. Please try again.");
        } finally {
          setLoading(false);
        }
      } else {
        setError("Invalid blog ID or URL.");
        setLoading(false);
        // Optionally navigate to a 404 page if no valid ID
        // navigate('/404');
      }
    };

    const fetchSidebarData = async () => {
      try {
        const response = await axios.get('https://fittex.io/jeevanapi/api/apptoodhublog?type=c');
        const data = response.data?.data;
        setCategories(Array.isArray(data?.blogCategoryInfo) ? data.blogCategoryInfo : []);
        setTags(Array.isArray(data?.blogTagInfo) ? data.blogTagInfo : []);
        setRecentPosts(Array.isArray(data?.blogInfo) ? data.blogInfo : []);
      } catch (error) {
        console.error("Error fetching sidebar data:", error);
        // Do not block main content if sidebar data fails
        setCategories([]);
        setTags([]);
        setRecentPosts([]);
      }
    };

    fetchMainBlogDetails();
    fetchSidebarData(); // Fetch sidebar data independently
  }, [location.state, slug, navigate]); // Dependencies for main blog fetch

  // Handle iframe load for dynamic height
  const handleIframeLoad = () => {
    const iframe = iframeRef.current;
    if (iframe) {
      try {
        // This attempts to get the scrollHeight of the iframe's content
        const newHeight = iframe.contentWindow.document.body.scrollHeight;
        iframe.style.height = `${newHeight + 50}px`; // Add some padding
      } catch (error) {
        // This error often occurs if the iframe content is from a different origin
        // due to same-origin policy restrictions.
        console.warn('Could not access iframe content for resizing (likely due to cross-origin policy):', error);
        // You might set a default height or handle this visually differently
        iframe.style.height = '2847px'; // Fallback to a reasonable default height
      }
    }
  };

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      // Navigate to the main blog list page with the search term
      navigate(`/blogs?SearchName=${encodeURIComponent(searchTerm.trim())}`);
    } else {
      navigate('/blogs'); // Navigate to all blogs if search term is empty
    }
  };

  if (loading) {
    return (
      <>
  
        <section className="blog-details mega-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center py-5">
                <p>Loading blog post...</p>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
    
        <section className="blog-details mega-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center py-5">
                <p>Error: {error}</p>
                <p>Please check the URL or try again later.</p>
                <Link to="/blogs" className="btn btn-primary">Go to Blog List</Link>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  if (!blog) {
    // This case should ideally be covered by 'error' state, but as a fallback.
    return (
      <>
       
        <section className="blog-details mega-section">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center py-5">
                <p>Blog post not found.</p>
                <Link to="/blogs" className="btn btn-primary">Go to Blog List</Link>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
         <div className="pricingnavbar menunavbar">
     <NavbarComponent />
     </div>
      {/* <Helmet>
        <link rel="icon" href={`${process.env.PUBLIC_URL}/assets/Images/fav-icon/fav-icon.png`} />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Nunito:wght@400;500;600;700;800;900&display=swap" />
      </Helmet> */}

         {blog && (
        <Helmet>
          <title>{blog.blog_Header}</title>
          <meta name="description" content={blog.description} />
          <meta property="og:title" content={blog.blog_Header} />
          <meta property="og:description" content={blog.description} />
          <meta property="og:image" content={blog.blog_Banner} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:type" content="article" />
        </Helmet>
      )}

      <section className="blog blog-home mega-section"> {/* Changed from blog-details to blog-home as it contains sidebar */}
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8 post-main-area">
              <nav aria-label="breadcrumb">
                <ul className="breadcrumb wow fadeInUp" data-wow-delay="1s">
                  <li className="breadcrumb-item">
                    <Link className="breadcrumb-link" to="/blogs">
                      <i className="fas fa-home icon"></i>home 
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Post single</li>
                </ul>
              </nav>

              <h1 className="post-title">{blog.blog_Header}</h1>
              <div className="social">
                <h6 className="share-title">share this post on:</h6>
                <div className="share-us">
                  <div className="sc-wraper dir-row sc-size-32">
                    <ul className="sc-list">
                      <li className="sc-item">
<a
  className="sc-link"
  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
  target="_blank"
  rel="noopener noreferrer"
>
  <i className="fab fa-facebook-f sc-icon"></i>
</a>
                      </li>
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.youtube.com/@Fittex_io" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-youtube sc-icon"></i>
                        </a>
                      </li>
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.instagram.com/fittex.io/" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-instagram sc-icon"></i>
                        </a>
                      </li>
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.linkedin.com/company/fittex-web/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-linkedin sc-icon"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="post-img-wraper post-featured-area">
                <img className="post-img" src={blog.blog_Banner} alt={blog.blog_Header} />
              </div>

              <div className="post-info">
                <Link className="info post-cat" to={`/blogs?categoryId=${blog.blog_CategoryId}`}>
                  <i className="fas fa-list-alt icon"></i>{blog.blog_Category}
                </Link>
                <span className="info post-author"><i className="fas fa-user icon"></i>{blog.author}</span>
                <span className="info post-date"><i className="fas fa-history icon"></i>{blog.blog_Date}</span>
                <span className="info post-time"><i className="fas fa-eye icon"></i>{blog.blog_Views}</span>
              </div>

              <div className="post-content">
                <p className="first-litter post-text">{blog.description}</p>
              </div>

              {/* Conditionally render iframe only if blog_LinkPage exists */}
              {blog.blog_LinkPage && (
                <iframe
                  ref={iframeRef}
                  src={blog.blog_LinkPage}
                  style={{
                    width: '100%',
                    border: 'none',
                    display: 'block',
                    minHeight: '400px', // Set a minimum height for when auto-resize fails
                  }}
                  scrolling="no"
                  title="Blog Page Content"
                  onLoad={handleIframeLoad}
                />
              )}

              <div className="tags panel">
                <ul className="sidebar-list tags-list">
                  <li className="tags-icon-label tagicn">
                    <i className="fas fa-tags icon" />
                  </li>
                  {blog.blog_Tags?.split(',').map((tag, index) => (
                    <li className="tag-item" key={index}>
                      <Link className="tag-link" to={`/blogs/tags/${slugify(tag.trim())}`}> {/* MODIFIED LINE */}
                        {tag.trim()}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>

            </div>

            {/* Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="blog-sidebar">

                {/* Search */}
                <div className="search sidebar-box">
                  <form className="search-form" onSubmit={handleSearchSubmit}>
                    <input
                      className="search-input"
                      type="search"
                      placeholder="Search Posts..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                    <button className="search-btn" type="submit"><i className="fas fa-search icon"></i></button>
                  </form>
                </div>


{/* Categories */}
<div className="cats sidebar-box">
  <h6 className="sidebar-box-title">
    <i className="fas fa-list-alt icon"></i>Categories:
  </h6>
  <ul className="sidebar-list cats-list">
    {categories.length > 0 ? categories.map((cat, idx) => (
      
      <li
  className="cat-item"
  key={idx} 
  style={{ cursor: "pointer" }}
>
<span className="cat-link">
  <Link
    className="post-link"
    // MODIFIED: Use the slug in the URL path
    to={`/blogs/category/${slugify(cat.blog_Category)}`}
    // Pass the categoryId and name in state so the target page can still fetch by ID if needed
    state={{ categoryId: cat.blog_CategoryId, categoryName: cat.blog_Category }}
  >
    {cat.blog_Category}
  </Link>
</span>
<span className="cat-count">
  <Link
    className="cat-count"
    // MODIFIED: Use the slug in the URL path
    to={`/blogs/category/${slugify(cat.blog_Category)}`}
    // Pass the categoryId and name in state
    state={{ categoryId: cat.blog_CategoryId, categoryName: cat.blog_Category }}
  >
    {cat.blog_CategoryCnt}
  </Link>
</span>
      
</li>
    )) : <li>No categories available.</li>}
  </ul>
</div>

            
                {/* Recent Posts */}
                <div className="recent-posts sidebar-box">
                  <h6 className="sidebar-box-title"><i className="fas fa-history icon"></i>Recent Posts:</h6>
                  <ul className="sidebar-list r-posts-list">
                    {recentPosts.slice(0, 5).map((rPost, idx) => { // Renamed 'post' to 'rPost' to avoid conflict with main 'blog'
                      const recentSlug = slugify(rPost.blog_Header);
                      return (
                        <li className="r-post-item" key={idx}>
                          <Link
                            to={`/blogs/${recentSlug}`}
                            state={{ blogId: rPost.blog_Id }}
                            className="r-post-link"
                          >
                            <div className="r-post-img-wraper">
                              <img className="r-post-img" src={rPost.blog_Banner} alt={rPost.blog_Header} />
                            </div>
                            <div className="content recentcontent">
                              <h6 className="r-post-title">{rPost.blog_Header}</h6>
                              <span className="r-post-date">{rPost.blog_Date}</span>
                            </div>
                          </Link>
                        </li>
                      )
                    })}
                  </ul>
                </div>

{/* Tags */}
<div className="tags sidebar-box">
  <h6 className="sidebar-box-title">
    <i className="fas fa-tags icon"></i>Tags:
  </h6>
  <ul className="sidebar-list tags-list">
    {tags.length > 0 ? tags.map((tag, idx) => (
      <li className="tag-item" key={idx}>
        <Link 
          target="_self" 
          className="tag-link" 
          to={`/blogs/tags/${slugify(tag.blog_Tag)}`} 
        >
          {tag.blog_Tag}
        </Link>
      </li>
    )) : <li>No tags available.</li>}
  </ul>
</div>

                {/* Social Icons */}
                <div className="follow-us sidebar-box">
                  <h6 className="sidebar-box-title"><i className="fas fa-heart icon"></i>Follow Us On:</h6>
                  <div className="sc-wraper dir-row sc-size-32">
                    <ul className="sc-list">
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.facebook.com/fittex.io" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-facebook-f sc-icon"></i>
                        </a>
                      </li>
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.youtube.com/@Fittex_io" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-youtube sc-icon"></i>
                        </a>
                      </li>
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.instagram.com/fittex.io/" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-instagram sc-icon"></i>
                        </a>
                      </li>
                      <li className="sc-item">
                        <a className="sc-link" href="https://www.linkedin.com/company/fittex-web/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
                          <i className="fab fa-linkedin sc-icon"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default BlogDetails;